import React, { useEffect, useState } from "react";
import { NavLink, useParams, useSearchParams } from "react-router-dom";
import Select from "react-select";
import { UrlWs } from "../../utils/Global";

async function cargar(idProcess = 7, direccion = 9999) {
  //const fetchReq1 = await fetch(UrlWs+ `/prequalifiers/${direccion}/process/${idProcess}`
/*  const fetchReq1 = await fetch(UrlWs + `/prequalifiers/${idProcess}/all`).then(
    (res) => res.json()
  );*/

  const fetchReq1 = await fetch(UrlWs + `/prequalifiers/${direccion}/process/${idProcess}`).then(
    (res) => res.json()
  );

  const allData = Promise.all([fetchReq1]);

  const opciones = allData.then((res) => {
    const opciones = res[0].map((d, index) => {
      const unidad =
        d.municipalUnit != null ? ` [${d.municipalUnit.name}]` : "";
      return {
        value: d.id_prequalifiers,
        label: `${d.officer.name_officer}${unidad}`,
        id_municipalUnit: d.id_municipalUnit,
      };
    });
    return opciones;
  });
  return opciones;
}

export const PrecalificadoresPorDireccion = ({
  updateValue,
  nuevoValue,
  direccion,
  disabled,
  idProcess,
  soloDireccion = false,
}) => {
  console.log('direccion es',direccion)
  let [searchParams, setSearchParams] = useSearchParams();
  //const idProcess = searchParams.get("idProcess");
  //const {idProcess}=useParams();

  const [datos, setDatos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [error, setError] = useState("");
  const [precalificadores, setPrecalificadores] = useState(null);

  useEffect(() => {
    setCargandoDatos(true);
    if (
      typeof direccion == "undefined" ||
      direccion == null ||
      direccion == ""
    ) {
      setCargandoDatos(false);
      setDatos([{ label: "Seleccione una dirección", value: 0 }]);
    } else {
      if (
        idProcess != null &&
        idProcess != "null" &&
        direccion != null &&
        direccion != "null"
      )
        cargar(idProcess, direccion).then((opciones) => {
          setCargandoDatos(false);
          console.log('cargar pre calificadores 2');
          //quitarle los precalificadores con unidad si esque viene el parámetro soloDirección como true.
          if (soloDireccion) {
            opciones.map((val, index) => {
              console.log(val);

              if (val.id_municipalUnit === null) {
                opciones.splice(index, 1);
                console.log(val);
              }
              //arr.splice(i, 1);
            });

            const unicos = [];
            const unicosLabel = [];

            const unique = opciones.filter((element) => {
              const isDuplicate = unicosLabel.includes(element.label);

              if (!isDuplicate) {
                unicos.push(element);
                unicosLabel.push(element.label);
                return true;
              }

              return false;
            });

            console.log("unicos");
            console.log(unicos);

            //setDatos(opciones);
            setDatos(unicos);
          } else {
            console.log("solo direcciones",soloDireccion);
            console.log(opciones);
            opciones.unshift({
              id_municipalUnit: "null",
              label: "Seleccione un precalificador",
              value:""
            });
            setDatos(opciones);
          }

          if (
            opciones != null &&
            typeof nuevoValue != "undefined" &&
            nuevoValue != null &&
            precalificadores != null &&
            nuevoValue != precalificadores.value
          ) {
            const opcion = datos.find((d) => d.value == nuevoValue);
            if (opcion != null) {
              setPrecalificadores(opcion);
              updateValue("precalificadores", opciones[0].value);
            } else {
              setPrecalificadores(opciones[0]);
              updateValue("precalificadores", opciones[0].value);
            }
          } else {
            setPrecalificadores(opciones[0]);
            updateValue("precalificadores", opciones[0].value);
          }
        });
    }
  }, [direccion]);

  useEffect(() => {
    if (datos != null && nuevoValue != null) {
      const opcion = datos.find((d) => d.value == nuevoValue);
      if (opcion != null) {
        setPrecalificadores(opcion);
      }
    }
  }, [nuevoValue]);

  return (
    <Select
      isDisabled={disabled}
      value={precalificadores}
      name="precalificadores"
      onChange={(choice) => {
        updateValue("precalificadores", choice.value);
        setPrecalificadores(choice);
      }}
      placeholder="Seleccione una dirección para ver opciones"
      options={
        cargandoDatos ? [{ value: "", label: "Cargando datos..." }] : datos
      }
    />
  );
};
